import type { GameBackgroundTuning } from "../scene/GameBackground";

// The background's VALUES — the only file to edit to retune how the factory is drawn. The shape is the background's.

export const BACKGROUND_TUNING: GameBackgroundTuning = {
  // 30 drawn frames a second: its motion is slow (the fountain's flipbook steps at 12) and each frame is a full-screen render.
  frameSeconds: 1 / 30,
  // 0.2 % over the screen, its still as much (`GameDefinition.background.overscan`): no edge shows at any size, and the
  // animation's first frame lands on the still.
  overscan: 1.002,
};
